import styled from 'styled-components';

import { DEFAULT_BACKGROUND_GRADIENT } from '../../../utils/colours';
import { isMobileApp } from '../../../utils/getHost';

export const AppLayoutContainer = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    ${({ $banner, $planCancelledBanner }) => {
        const hasBanner = $banner;
        const hasPlanCancelledBanner = $planCancelledBanner;

        if (hasBanner && hasPlanCancelledBanner) {
            return `
                grid-template-rows: min-content min-content 1fr;
                grid-template-areas:
                    "sidebar banner"
                    "sidebar plan-cancelled-banner"
                    "sidebar content";
            `;
        } else if (hasBanner) {
            return `
                grid-template-rows: min-content 1fr;
                grid-template-areas:
                    "sidebar banner"
                    "sidebar content";
            `;
        } else if (hasPlanCancelledBanner) {
            return `
                grid-template-rows: min-content 1fr;
                grid-template-areas:
                    "sidebar plan-cancelled-banner"
                    "sidebar content";
            `;
        } else {
            return `
                grid-template-rows: auto;
                grid-template-areas:
                    "sidebar content";
            `;
        }
    }}

    height: 100vh;
    overflow: hidden;

    ${({ $banner, $planCancelledBanner, $mobileBreakpoint }) => {
        const hasBanner = $banner;
        const hasPlanCancelledBanner = $planCancelledBanner;

        if (isMobileApp) {
            if (hasBanner && hasPlanCancelledBanner) {
                return `
                    grid-template-columns: auto;
                    grid-template-rows: auto min-content min-content 1fr auto;
                    grid-template-areas:
                        "mobile-app-header"
                        "banner"
                        "plan-cancelled-banner"
                        "content"
                        "sidebar";
                `;
            } else if (hasBanner) {
                return `
                    grid-template-columns: auto;
                    grid-template-rows: auto min-content 1fr auto;
                    grid-template-areas:
                        "mobile-app-header"
                        "banner"
                        "content"
                        "sidebar";
                `;
            } else if (hasPlanCancelledBanner) {
                return `
                    grid-template-columns: auto;
                    grid-template-rows: auto min-content 1fr auto;
                    grid-template-areas:
                        "mobile-app-header"
                        "plan-cancelled-banner"
                        "content"
                        "sidebar";
                `;
            } else {
                return `
                    grid-template-columns: auto;
                    grid-template-rows: auto 1fr auto;
                    grid-template-areas:
                        "mobile-app-header"
                        "content"
                        "sidebar";
                `;
            }
        } else {
            if (hasBanner && hasPlanCancelledBanner) {
                return `
                    @media only screen and (max-width: ${$mobileBreakpoint}px) {
                        grid-template-columns: auto;
                        grid-template-rows: auto min-content min-content 1fr;
                        grid-template-areas:
                            "sidebar"
                            "banner"
                            "plan-cancelled-banner"
                            "content";
                    }
                `;
            } else if (hasBanner) {
                return `
                    @media only screen and (max-width: ${$mobileBreakpoint}px) {
                        grid-template-columns: auto;
                        grid-template-rows: auto min-content 1fr;
                        grid-template-areas:
                            "sidebar"
                            "banner"
                            "content";
                    }
                `;
            } else if (hasPlanCancelledBanner) {
                return `
                    @media only screen and (max-width: ${$mobileBreakpoint}px) {
                        grid-template-columns: auto;
                        grid-template-rows: auto min-content 1fr;
                        grid-template-areas:
                            "sidebar"
                            "plan-cancelled-banner"
                            "content";
                    }
                `;
            } else {
                return `
                    @media only screen and (max-width: ${$mobileBreakpoint}px) {
                        grid-template-columns: auto;
                        grid-template-rows: auto 1fr;
                        grid-template-areas:
                            "sidebar"
                            "content";
                    }
                `;
            }
        }
    }}

    /*
        Mobile app: while a camera is fullscreen (the camera page sets data-app-fullscreen on <body>), hide everything but the
        page so the header and the footer navigation are gone and the page fills the screen.
    */
    ${isMobileApp ? `
        body[data-app-fullscreen='true'] & {
            & > *:not(main) {
                display: none;
            }

            & > main {
                padding: 0;
            }
        }
    ` : ''}
`;

AppLayoutContainer.displayName = 'AppLayoutContainer';


export const SidebarContainer = styled.div`
    grid-area: sidebar;
`;

SidebarContainer.displayName = 'SidebarContainer';


export const BannerContainer = styled.div`
    grid-area: banner;
    display: flex;
    flex-direction: column;
`;

BannerContainer.displayName = 'BannerContainer';


export const Banner = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 16px;
    gap: 16px;

    p {
        flex-grow: 1;
        margin: 0;
        text-align: center;
    }
`;

Banner.displayName = 'Banner';


export const DevelopmentSiteBanner = styled(Banner)`
    background: #F6C344;
    color: #1D1D1D;
`;

DevelopmentSiteBanner.displayName = 'DevelopmentSiteBanner';


export const PlanCancelledBanner = styled.div`
    grid-area: plan-cancelled-banner;
    display: flex;
    align-items: center;
    padding: 10px 16px;
    gap: 16px;
    background: #E32747;
    color: white;

    p {
        flex-grow: 1;
        margin: 0;
        text-align: center;
    }
`;

PlanCancelledBanner.displayName = 'PlanCancelledBanner';


export const PageContent = styled.main`
    grid-area: content;
    background: ${({$background}) => $background ? $background : DEFAULT_BACKGROUND_GRADIENT};
    flex-grow: 1;
    padding: ${({$fullWidth}) => $fullWidth ? 0 : `min(20px, 3.5%) min(30px, 2.5%)`};
    overflow-y: auto;
    position: relative;
`;

PageContent.displayName = 'PageContent';
